__turbopack_context__.v({
  "inlineVAT": "TotalPrice-module__Dg2hia__inlineVAT",
  "priceContainer": "TotalPrice-module__Dg2hia__priceContainer",
  "totalPrice": "TotalPrice-module__Dg2hia__totalPrice",
  "vat": "TotalPrice-module__Dg2hia__vat",
});
